import React from "react";
import classNames from "classnames";

import { TextAreaInterface } from "../FormControl";
import styles from "./Textarea.module.scss";

type Props = Omit<TextAreaInterface, "type">;

const Textarea: React.FC<Props> = ({
  cols = 30,
  rows = 10,
  dataQA,
  error,
  label,
  id,
  value,
  ...textareaProps
}) => {
  const hasError = Boolean(error);
  const errorId = hasError ? `${id}-error` : undefined;
  const textareaValue = value ?? "";

  return (
    <div data-qa={dataQA} className={styles.container}>
      {label && (
        <label
          htmlFor={id}
          className={classNames(styles.label, {
            [styles.errorLabel]: hasError,
          })}
        >
          {label}
        </label>
      )}
      <textarea
        cols={cols}
        rows={rows}
        className={classNames(styles.textarea, {
          [styles.errorInput]: hasError,
        })}
        {...textareaProps}
        id={id}
        value={textareaValue}
        aria-invalid={hasError}
        aria-describedby={errorId}
      />
      {hasError && (
        <span className={styles.errorText} id={errorId}>
          {error}
        </span>
      )}
    </div>
  );
};

export default Textarea;
